var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _abortController, _cachedContent, _cartUpdateAbortController, _QuickAddComponent_instances, getSelectedVariantId_fn, _handleCartUpdate, updateVariantPicker_fn, resetScroll_fn, stayVisibleUntilDialogCloses_fn, _openQuickAddModal, _closeQuickAddModal, updateQuickAddButtonState_fn, syncVariantSelection_fn, _abortController2, _updateProductTitleLink, _handleDialogClose;
import { morph } from "@theme/morph";
import { Component } from "@theme/component";
import { CartUpdateEvent, ThemeEvents, VariantSelectedEvent } from "@theme/events";
import { DialogComponent, DialogCloseEvent } from "@theme/dialog";
import { mediaQueryLarge, isMobileBreakpoint, getIOSVersion } from "@theme/utilities";
import VariantPicker from "@theme/variant-picker";
class QuickAddComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _QuickAddComponent_instances);
    /** @type {AbortController | null} */
    __privateAdd(this, _abortController, null);
    /** @type {Map<string, Element>} */
    __privateAdd(this, _cachedContent, /* @__PURE__ */ new Map());
    /** @type {AbortController} */
    __privateAdd(this, _cartUpdateAbortController, new AbortController());
    /**
     * Clears the cached content when cart is updated
     */
    __privateAdd(this, _handleCartUpdate, () => {
      __privateGet(this, _cachedContent).clear();
    });
    /**
     * Handles quick add button click
     * @param {Event} event - The click event
     */
    __publicField(this, "handleClick", async (event) => {
      event.preventDefault();
      const currentUrl = this.productPageUrl;
      let productGrid = __privateGet(this, _cachedContent).get(currentUrl);
      if (!productGrid) {
        const html = await this.fetchProductPage(currentUrl);
        if (html) {
          const gridElement = html.querySelector("[data-product-grid-content]");
          if (gridElement) {
            productGrid = /** @type {Element} */
            gridElement.cloneNode(true);
            __privateGet(this, _cachedContent).set(currentUrl, productGrid);
          }
        }
      }
      if (productGrid) {
        const freshContent = (
          /** @type {Element} */
          productGrid.cloneNode(true)
        );
        await this.updateQuickAddModal(freshContent);
        __privateMethod(this, _QuickAddComponent_instances, updateVariantPicker_fn).call(this, productGrid);
      }
      __privateGet(this, _openQuickAddModal).call(this);
    });
    __privateAdd(this, _openQuickAddModal, () => {
      const dialogComponent = document.getElementById("quick-add-dialog");
      if (!(dialogComponent instanceof QuickAddDialog)) return;
      __privateMethod(this, _QuickAddComponent_instances, stayVisibleUntilDialogCloses_fn).call(this, dialogComponent);
      dialogComponent.showDialog();
      const dialog = dialogComponent.refs?.dialog;
      if (!dialog) return;
      dialog.addEventListener("animationstart", __privateMethod(this, _QuickAddComponent_instances, resetScroll_fn).bind(this), { once: true });
    });
    __privateAdd(this, _closeQuickAddModal, () => {
      const dialogComponent = document.getElementById("quick-add-dialog");
      if (!(dialogComponent instanceof QuickAddDialog)) return;
      dialogComponent.closeDialog();
    });
  }
  get productPageUrl() {
    const productCard = (
      /** @type {import('./product-card').ProductCard | null} */
      this.closest("product-card")
    );
    const hotspotProduct = (
      /** @type {import('./product-hotspot').ProductHotspotComponent | null} */
      this.closest("product-hotspot-component")
    );
    const productLink = productCard?.getProductCardLink() || hotspotProduct?.getHotspotProductLink();
    if (!productLink?.href) return "";
    const url = new URL(productLink.href);
    if (url.searchParams.has("variant")) {
      return url.toString();
    }
    const selectedVariantId = __privateMethod(this, _QuickAddComponent_instances, getSelectedVariantId_fn).call(this);
    if (selectedVariantId) {
      url.searchParams.set("variant", selectedVariantId);
    }
    return url.toString();
  }
  connectedCallback() {
    super.connectedCallback();
    mediaQueryLarge.addEventListener("change", __privateGet(this, _closeQuickAddModal));
    document.addEventListener(ThemeEvents.cartUpdate, __privateGet(this, _handleCartUpdate), {
      signal: __privateGet(this, _cartUpdateAbortController).signal
    });
    document.addEventListener(ThemeEvents.variantSelected, __privateMethod(this, _QuickAddComponent_instances, updateQuickAddButtonState_fn).bind(this));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    mediaQueryLarge.removeEventListener("change", __privateGet(this, _closeQuickAddModal));
    __privateGet(this, _abortController)?.abort();
    __privateGet(this, _cartUpdateAbortController).abort();
    document.removeEventListener(ThemeEvents.variantSelected, __privateMethod(this, _QuickAddComponent_instances, updateQuickAddButtonState_fn).bind(this));
  }
  /**
   * Fetches the product page content
   * @param {string} productPageUrl - The URL of the product page to fetch
   * @returns {Promise<Document | null>}
   */
  async fetchProductPage(productPageUrl) {
    if (!productPageUrl) return null;
    __privateGet(this, _abortController)?.abort();
    __privateSet(this, _abortController, new AbortController());
    try {
      const response = await fetch(productPageUrl, {
        signal: __privateGet(this, _abortController).signal
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch product page: HTTP error ${response.status}`);
      }
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, "text/html");
      return html;
    } catch (error) {
      if (error.name === "AbortError") {
        return null;
      } else {
        throw error;
      }
    } finally {
      __privateSet(this, _abortController, null);
    }
  }
  /**
   * Re-renders the variant picker.
   * @param {Element} productGrid - The product grid element
   */
  async updateQuickAddModal(productGrid) {
    const modalContent = document.getElementById("quick-add-modal-content");
    if (!productGrid || !modalContent) return;
    if (isMobileBreakpoint()) {
      const productDetails = productGrid.querySelector(".product-details");
      const productFormComponent = productGrid.querySelector("product-form-component");
      const variantPicker = productGrid.querySelector("variant-picker");
      const productPrice = productGrid.querySelector("product-price");
      const productTitle = document.createElement("a");
      productTitle.textContent = this.dataset.productTitle || "";
      productTitle.href = this.productPageUrl;
      const productHeader = document.createElement("div");
      productHeader.classList.add("product-header");
      productHeader.appendChild(productTitle);
      if (productPrice) {
        productHeader.appendChild(productPrice);
      }
      productGrid.appendChild(productHeader);
      if (variantPicker) {
        productGrid.appendChild(variantPicker);
      }
      if (productFormComponent) {
        productGrid.appendChild(productFormComponent);
      }
      productDetails?.remove();
    }
    morph(modalContent, productGrid);
    __privateMethod(this, _QuickAddComponent_instances, syncVariantSelection_fn).call(this, modalContent);
  }
}
_abortController = new WeakMap();
_cachedContent = new WeakMap();
_cartUpdateAbortController = new WeakMap();
_QuickAddComponent_instances = new WeakSet();
/**
 * Gets the currently selected variant ID from the product card
 * @returns {string | null} The variant ID or null
 */
getSelectedVariantId_fn = function() {
  const productCard = (
    /** @type {import('./product-card').ProductCard | null} */
    this.closest("product-card")
  );
  return productCard?.getSelectedVariantId() || null;
};
_handleCartUpdate = new WeakMap();
/**
 * Re-renders the variant picker in the quick-add modal.
 * @param {Element} newHtml - The element to re-render.
 */
updateVariantPicker_fn = function(newHtml) {
  const modalContent = document.getElementById("quick-add-modal-content");
  if (!modalContent) return;
  const variantPicker = (
    /** @type {VariantPicker | null} */
    modalContent.querySelector("variant-picker")
  );
  if (!variantPicker) return;
  variantPicker.updateVariantPicker(newHtml);
};
resetScroll_fn = function() {
  const dialogComponent = document.getElementById("quick-add-dialog");
  if (!(dialogComponent instanceof QuickAddDialog)) return;
  const productDetails = dialogComponent.querySelector(".product-details");
  const productMedia = dialogComponent.querySelector(".product-information__media");
  productDetails?.scrollTo({ top: 0, behavior: "instant" });
  productMedia?.scrollTo({ top: 0, behavior: "instant" });
};
/** @param {QuickAddDialog} dialogComponent */
stayVisibleUntilDialogCloses_fn = function(dialogComponent) {
  this.toggleAttribute("stay-visible", true);
  dialogComponent.addEventListener(DialogCloseEvent.eventName, () => this.toggleAttribute("stay-visible", false), {
    once: true
  });
};
_openQuickAddModal = new WeakMap();
_closeQuickAddModal = new WeakMap();
/**
 * Updates the quick-add button state based on whether a swatch is selected
 * @param {VariantSelectedEvent} event - The variant selected event
 */
updateQuickAddButtonState_fn = function(event) {
  if (!(event.target instanceof HTMLElement)) return;
  if (event.target.closest("product-card") !== this.closest("product-card")) return;
  const productOptionsCount = this.dataset.productOptionsCount;
  const quickAddButton = productOptionsCount === "1" ? "add" : "choose";
  this.setAttribute("data-quick-add-button", quickAddButton);
};
/**
 * Syncs the variant selection from the product card to the modal
 * @param {Element} modalContent - The modal content element
 */
syncVariantSelection_fn = function(modalContent) {
  const selectedVariantId = __privateMethod(this, _QuickAddComponent_instances, getSelectedVariantId_fn).call(this);
  if (!selectedVariantId) return;
  const modalInputs = modalContent.querySelectorAll('input[type="radio"][data-variant-id]');
  for (const input of modalInputs) {
    if (input instanceof HTMLInputElement && input.dataset.variantId === selectedVariantId && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      break;
    }
  }
};
if (!customElements.get("quick-add-component")) {
  customElements.define("quick-add-component", QuickAddComponent);
}
class QuickAddDialog extends DialogComponent {
  constructor() {
    super(...arguments);
    __privateAdd(this, _abortController2, new AbortController());
    /**
     * Closes the dialog
     * @param {CartUpdateEvent} event - The cart update event
     */
    __publicField(this, "handleCartUpdate", (event) => {
      if (event.detail.data.didError) return;
      this.closeDialog();
    });
    __privateAdd(this, _updateProductTitleLink, (event) => {
      const anchorElement = (
        /** @type {HTMLAnchorElement} */
        event.detail.data.html?.querySelector(".view-product-title a")
      );
      const viewMoreDetailsLink = (
        /** @type {HTMLAnchorElement} */
        this.querySelector(".view-product-title a")
      );
      const mobileProductTitle = (
        /** @type {HTMLAnchorElement} */
        this.querySelector(".product-header a")
      );
      if (!anchorElement) return;
      if (viewMoreDetailsLink) viewMoreDetailsLink.href = anchorElement.href;
      if (mobileProductTitle) mobileProductTitle.href = anchorElement.href;
    });
    __privateAdd(this, _handleDialogClose, () => {
      const iosVersion = getIOSVersion();
      if (!iosVersion || iosVersion.major >= 17 || iosVersion.major === 16 && iosVersion.minor >= 4) return;
      requestAnimationFrame(() => {
        const grid = document.querySelector("#ResultsList [product-grid-view]");
        if (grid) {
          const currentWidth = grid.getBoundingClientRect().width;
          grid.style.width = `${currentWidth - 1}px`;
          requestAnimationFrame(() => {
            grid.style.width = "";
          });
        }
      });
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate, { signal: __privateGet(this, _abortController2).signal });
    this.addEventListener(ThemeEvents.variantUpdate, __privateGet(this, _updateProductTitleLink));
    this.addEventListener(DialogCloseEvent.eventName, __privateGet(this, _handleDialogClose));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateGet(this, _abortController2).abort();
    this.removeEventListener(DialogCloseEvent.eventName, __privateGet(this, _handleDialogClose));
  }
}
_abortController2 = new WeakMap();
_updateProductTitleLink = new WeakMap();
_handleDialogClose = new WeakMap();
if (!customElements.get("quick-add-dialog")) {
  customElements.define("quick-add-dialog", QuickAddDialog);
}
export {
  QuickAddComponent
};
